/**
 * useTutorInvoicesData — la lecture paginée de « Mes factures » (`getTutoringInvoices`, `?page=`).
 *
 * Patron A, comme `useLiveReportsData` : la première page à l'ouverture (elle remplace la liste du
 * réducteur `tutors`), la suite sur « Voir plus » (elle s'y ajoute) ; le curseur se recopie du `meta`
 * de chaque réponse (`useApiPagedFetch`). `answered` dit que la première page de CETTE ouverture est
 * là : le view-model ne montre pas avant la liste gardée d'une visite précédente. Une suite qui
 * échoue laisse « Voir plus » pour réessayer la même page.
 */
import { tutorsService } from "../../../../../../data/services/tutorsService"
import { useApiPagedFetch } from "../../../hooks/useApiPagedFetch"

export function useTutorInvoicesData() {
    const pages = useApiPagedFetch({ service: tutorsService.getTutoringInvoices })
    return {
        answered: pages.answered,
        hasMore: pages.hasMore,
        loadMore: pages.loadMore,
        reload: () => pages.refresh(),
    }
}
